import { render, staticRenderFns } from "./AgeGatem.vue?vue&type=template&id=3c046a93&scoped=true"
import script from "./AgeGatem.vue?vue&type=script&lang=js"
export * from "./AgeGatem.vue?vue&type=script&lang=js"
import style0 from "./AgeGatem.vue?vue&type=style&index=0&id=3c046a93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c046a93",
  null
  
)

export default component.exports